// 재생목록 대표 VOD만 노출
export const REP_PLAYLIST = "REP_PLAYLIST";

// 재생목록 모든 VOD 노출
export const HOME_PLAYLIST = "HOME_PLAYLIST";